module.exports = __webpack_public_path__ + "img/suo.456a0920.png";